<p class="content-option-row-label" translate>Every</p>
<rotec-number-input-panel-v2
  class="number-input-panel"
  [darkMode]="true"
  [min]="1"
  [value]="interval"
  (valueChange)="changeInterval($event)"
></rotec-number-input-panel-v2>
<div class="label-spacing" translate>Day(s)</div>
